import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { concatMap, filter, map, tap } from "rxjs";
import { SharedActions } from "./shared-action-types";
import { UserPreferencesService } from "../services/user-preferences.service";

@Injectable()
export class UserPreferencesEffects {
  loadUserPreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.loadUserPreferences),
      concatMap(() => this.userPreferencesSvc.getPreferences()),
      map((preferences) =>
        SharedActions.userPreferencesLoaded({ preferences }),
      ),
    ),
  );

  setUserPreferencesOrderViewType$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.setUserPreferencesOrderViewType),
        tap(({ viewType }) => this.userPreferencesSvc.saveOrderView(viewType)),
      ),
    { dispatch: false },
  );

  setUserPreferencesAccountViewType$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.setUserPreferencesAccountViewType),
        tap(({ viewType }) => this.userPreferencesSvc.saveAccountView(viewType)),
      ),
    { dispatch: false },
  );

  setUserPreferencesCompanyAccountViewType$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.setUserPreferencesCompanyAccountViewType),
        tap(({ viewType }) => this.userPreferencesSvc.saveCompanyAccountView(viewType)),
      ),
    { dispatch: false },
  );

  addUserFavorites$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(SharedActions.addUserFavorites),
      filter(({ favorite }) => favorite.pageKey !== 'FAKE_URL'),
      tap(({ favorite }) =>
        this.userPreferencesSvc.addRemoveUserFavorite(favorite)
      ),
    ),
  { dispatch: false },
);

removeUserFavorites$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(SharedActions.removeUserFavorites),
      filter(({ favorite }) => favorite.pageKey !== 'FAKE_URL'),
      tap(({ favorite }) =>
        this.userPreferencesSvc.addRemoveUserFavorite(favorite)
      ),
    ),
  { dispatch: false },
);


  constructor(
    private actions$: Actions,
    private userPreferencesSvc: UserPreferencesService,
  ) { }
}
